import { Navigate, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import SvarUtBrevHistorikk from "../components/Common/Detalj/SvarUtBrevhistorikk";
import IleggelseOrginalbilde from "../components/Common/Ileggelser/Detalj/IleggelseOrginalbilde";
import IleggelseImageEditorPageContainer from "../components/Common/Ileggelser/Detalj/ImageEditorPageContainer";
import IleggelseDetaljPage from "../components/Ileggelse/Detalj/IleggelseDetaljPage";
import ElsparksykkelGebyrPage from "../components/Ileggelse/ElsparksykkelGebyr/ElsparksykkelGebyrPage";
import UtskriftContainerELS from "../components/Ileggelse/ElsparksykkelGebyr/UtskriftContainerELS";
import EttersendelserPage from "../components/Ileggelse/Ettersendelse/EttersendelserPage";
import EttersendelserUtskriftContainer from "../components/Ileggelse/Ettersendelse/UtskriftContainer";
import EttersendelserTilGodkjenningPage from "../components/Ileggelse/EttersendelserTilGodkjenning/EttersendelserTilGodkjenningPage";
import OversiktContainer from "../components/Ileggelse/Oversikt/OversiktPage";
import OversiktUtskriftContainer from "../components/Ileggelse/Oversikt/UtskriftContainer";

import { bypatruljen, juridisk } from "../constants/roles";
import sitePath from "../constants/sitePaths";

// Role groups shared across subsections
const ALL = [...Object.values(bypatruljen), ...Object.values(juridisk)];
const ETT_LIST = [
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  bypatruljen.avdelingdirektor,
  bypatruljen.seksjonssjefStab,
];
const ETG = [bypatruljen.saksbehandler, bypatruljen.saksbehandleradmin];
const ELSP = [
  ...ETT_LIST,
  bypatruljen.seksjonssjef,
  bypatruljen.driftleder,
  juridisk.ledelse,
  juridisk.saksbehandler,
];
const SVAT = [
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  juridisk.ledelse,
  juridisk.saksbehandler,
];
const SVAT_ETT = [bypatruljen.saksbehandler, bypatruljen.saksbehandleradmin];
const EDIT = [
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
  juridisk.saksbehandler,
];

const Ileggelser = () => (
  <Routes>
    {/* oversikt */}
    <Route path="oversikt">
      <Route
        index
        element={
          <AuthorizedRoute roles={ALL}>
            <OversiktContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path="utskrift"
        element={
          <AuthorizedRoute roles={ALL}>
            <OversiktUtskriftContainer />
          </AuthorizedRoute>
        }
      />
      <Route path=":id">
        <Route
          index
          element={
            <AuthorizedRoute roles={ALL}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route path="bilder/:bildeId">
          <Route
            index
            element={
              <AuthorizedRoute roles={ALL}>
                <IleggelseOrginalbilde />
              </AuthorizedRoute>
            }
          />
          <Route
            path="rediger"
            element={
              <AuthorizedRoute roles={EDIT}>
                <IleggelseImageEditorPageContainer />
              </AuthorizedRoute>
            }
          />
        </Route>
        <Route
          path="svar-ut/:svarUtId/historikk"
          element={
            <AuthorizedRoute roles={SVAT}>
              <SvarUtBrevHistorikk />
            </AuthorizedRoute>
          }
        />
      </Route>
    </Route>

    {/* ettersendelser */}
    <Route path="ettersendelser">
      <Route
        index
        element={
          <AuthorizedRoute roles={ETT_LIST}>
            <EttersendelserPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="utskrift"
        element={
          <AuthorizedRoute roles={ETT_LIST}>
            <EttersendelserUtskriftContainer />
          </AuthorizedRoute>
        }
      />
      <Route path=":id">
        <Route
          index
          element={
            <AuthorizedRoute roles={ALL}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route path="bilder/:bildeId">
          <Route
            index
            element={
              <AuthorizedRoute roles={ALL}>
                <IleggelseOrginalbilde />
              </AuthorizedRoute>
            }
          />
          <Route
            path="rediger"
            element={
              <AuthorizedRoute roles={EDIT}>
                <IleggelseImageEditorPageContainer />
              </AuthorizedRoute>
            }
          />
        </Route>
        <Route
          path="svar-ut/:svarUtId/historikk"
          element={
            <AuthorizedRoute roles={SVAT_ETT}>
              <SvarUtBrevHistorikk />
            </AuthorizedRoute>
          }
        />
      </Route>
    </Route>

    {/* ettersendelser-til-godkjenning */}
    <Route path="ettersendelser-til-godkjenning">
      <Route
        index
        element={
          <AuthorizedRoute roles={ETG}>
            <EttersendelserTilGodkjenningPage />
          </AuthorizedRoute>
        }
      />
      <Route path=":id">
        <Route
          index
          element={
            <AuthorizedRoute roles={ALL}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route path="bilder/:bildeId">
          <Route
            index
            element={
              <AuthorizedRoute roles={ALL}>
                <IleggelseOrginalbilde />
              </AuthorizedRoute>
            }
          />
          <Route
            path="rediger"
            element={
              <AuthorizedRoute roles={EDIT}>
                <IleggelseImageEditorPageContainer />
              </AuthorizedRoute>
            }
          />
        </Route>
        <Route
          path="svar-ut/:svarUtId/historikk"
          element={
            <AuthorizedRoute roles={SVAT_ETT}>
              <SvarUtBrevHistorikk />
            </AuthorizedRoute>
          }
        />
      </Route>
    </Route>

    {/* elsparksykkel-gebyr */}
    <Route path="elsparksykkel-gebyr">
      <Route
        index
        element={
          <AuthorizedRoute roles={ELSP}>
            <ElsparksykkelGebyrPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="utskrift"
        element={
          <AuthorizedRoute roles={ALL}>
            <UtskriftContainerELS />
          </AuthorizedRoute>
        }
      />
      <Route path=":id">
        <Route
          index
          element={
            <AuthorizedRoute roles={ELSP}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route path="bilder/:bildeId">
          <Route
            index
            element={
              <AuthorizedRoute roles={ELSP}>
                <IleggelseOrginalbilde />
              </AuthorizedRoute>
            }
          />
          <Route
            path="rediger"
            element={
              <AuthorizedRoute roles={EDIT}>
                <IleggelseImageEditorPageContainer />
              </AuthorizedRoute>
            }
          />
        </Route>
        <Route
          path="svar-ut/:svarUtId/historikk"
          element={
            <AuthorizedRoute roles={SVAT}>
              <SvarUtBrevHistorikk />
            </AuthorizedRoute>
          }
        />
      </Route>
    </Route>

    <Route
      index
      element={<Navigate to={sitePath.ileggelser.oversikt.shortUrl} replace />}
    />
  </Routes>
);

export default Ileggelser;
